import { createTranslator } from 'use-intl/core'

import { en } from './en'
import { fr } from './fr'

/**
 * Shared i18n entry point, usable from Next.js apps and Lambdas alike.
 *
 * IMPORTANT: keep in sync with the mirrored copy at packages/functions/src/shared/i18n/index.ts.
 */

export const SITE_LANGUAGES = ['en', 'fr'] as const
export type SiteLanguageCode = (typeof SITE_LANGUAGES)[number]
export const DEFAULT_SITE_LANGUAGE: SiteLanguageCode = 'en'

export const sharedMessages = { en, fr } as const
export type SharedMessages = typeof en

/** Narrows any stored/nullable language value to a supported code, defaulting to English. */
export const resolveSiteLanguage = (language: string | null | undefined): SiteLanguageCode =>
  language === 'fr' ? 'fr' : 'en'

/**
 * ICU translator over the shared catalog for use outside React (Lambdas, API routes).
 * Usage: const t = getSharedTranslator(site.language); t('newsletter.unsubscribe')
 */
export const getSharedTranslator = (language: string | null | undefined) => {
  const locale = resolveSiteLanguage(language)
  return createTranslator({ locale, messages: sharedMessages[locale] })
}
